module.exports = __webpack_public_path__ + "img/spinner.6f3f8b45.svg";